import React from "react";

import { YMInitializer } from "react-yandex-metrika";

import { Content as ContentComponent, Loader } from "./components/composite";
import { Modal, Tutorial } from "src/components/widgets";
import { useConnect, useContent, useSubscribe } from "./hooks";
import { Content } from "./types";

const Desktop = React.lazy(() => import("src/components/views/Desktop"));
const Mobile = React.lazy(() => import("src/components/views/Mobile"));
const Laptop = React.lazy(() => import("src/components/views/Laptop"));
const V3 = React.lazy(() => import("src/components/views/V3"));

const CONTENT: Record<Content, React.ReactNode> = {
  desktop: <Desktop />,
  mobile: <Mobile />,
  laptop: <Laptop />,
  v3: <V3 />,
};

export const App = React.memo(() => {
  useSubscribe();
  useConnect();

  const content = useContent();
  const contentComponent = CONTENT[content];

  return (
    <>
      <Loader />
      <Tutorial />
      <Modal />
      <ContentComponent>
        <React.Suspense>{contentComponent}</React.Suspense>
      </ContentComponent>
      <YMInitializer accounts={[97592231]} />
    </>
  );
});

App.displayName = "App";
